<template>
    <div class="infopoints_view">
        <b-container fluid>
            <b-row>
                <b-col cols="8">
                    <card>
                        <InfopointLayoutsTable ref="infopointLayoutsTable" @selectItem="onSelectItem"
                            @newItem="onNewItem" :item="item ? item.id : null">
                        </InfopointLayoutsTable>
                    </card>
                </b-col>
                <b-col cols="4">
                    <InfoCard v-if="action == ''"></InfoCard>
                    <card class="infopointsdisplays" v-if="action == 'item' && item">
                        <CardHeader :title="this.item.name" type="item" />
                        <tabs>
                            <tab-pane title="tab-3" key="tab-3" v-if="$UIPrivilege('devices/infopoints', 'status')">
                                <b-icon id="status-icon" slot="title" icon="gear" scale='1.1'></b-icon>
                                <b-popover target="status-icon" triggers="hover" placement="top">
                                    {{ $t('infopointlayouts.settings') }}
                                </b-popover>
                                <InfopointBasicInformation :item="item">
                                </InfopointBasicInformation>
                            </tab-pane>
                            <tab-pane title="tab-4" key="tab-4" v-if="$UIPrivilege('devices/infopoints', 'layout')">
                                <b-icon id="columns" slot="title" icon="list-ol" scale='1.1'></b-icon>
                                <b-popover target="columns" triggers="hover" placement="top">
                                    {{ $t('infopointlayouts.usage.label') }}
                                </b-popover>
                                <InforpointsLayoutsDisplays :item="item"></InforpointsLayoutsDisplays>
                            </tab-pane>
                            <tab-pane title="tab-5" key="tab-5" v-if="$UIPrivilege('devices/infopoints', 'status')">
                                <b-icon id="preview-icon" slot="title" icon="eye" scale='1.1'></b-icon>
                                <b-popover target="preview-icon" triggers="hover" placement="top">
                                    {{ $t('infopointlayouts.preview') }}
                                </b-popover>
                                <InfopointLayoutPreview :item="item"></InfopointLayoutPreview>
                            </tab-pane>
                        </tabs>
                    </card>

                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>

import InfopointLayoutsTable from '@/components/Content/Layout/InfopointLayoutsTable'
import InfopointBasicInformation from '@/components/Content/Layout/InfopointBasicInformation'
import InforpointsLayoutsDisplays from '@/components/Content/Layout/InforpointsLayoutsDisplays.vue';
import InfopointLayoutPreview from '@/components/Content/Layout/InfopointLayoutPreview.vue';

export default {
    name: 'Infopoints',
    components: {
        InfopointLayoutsTable,
        InfopointBasicInformation,
        InforpointsLayoutsDisplays,
        InfopointLayoutPreview
    },
    data: function () {
        return {
            action: "",
            item: {}
        }
    },
    mounted() {
        if (this.$route.query.uniqueId) {
            var filtervalue = this.$route.query.uniqueId;
            this.$refs.infopointTable.setFilterValue(filtervalue);
        }
    },

    methods: {
        onNewItem() {
            this.item = null;
            this.action = "new"
        },
        itemId(item) {
            this.item = item;
            return 'id'
        },
        onSelectItem(item) {
            this.item = item;
            this.action = "item"
        }
    }
}
</script>


<style scoped lang="scss">
/*
.infopoints_view {
    font-weight: normal;
}
.infopoints_view {
    max-width: 95em;
}
.infopointsdisplays {
    width:35em;
}
*/
</style>